import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxLoadingModule } from 'ngx-loading';
import { SharedModule } from '@app/shared';
import { TaskItemComponent } from './components/task-item/task-item.component';
import { TaskDetailComponent } from './modals/task-detail/task-detail.component';
import { TaskNotificationModal } from './modals/task-notification/task-notification.modal';

@NgModule({
  imports: [CommonModule, SharedModule, NgxLoadingModule, MatTooltipModule],
  declarations: [TaskItemComponent, TaskDetailComponent, TaskNotificationModal],
  exports: [TaskItemComponent, TaskNotificationModal],
  entryComponents: [TaskDetailComponent, TaskNotificationModal],
})
export class ChecklistModule {}
